import { IDynamicPage, TIdToPageMap } from 'models/common.model'
import { Cohort } from 'root-constants'
import { PurchaseVariant1 } from 'modules/purchase/pages/PurchaseVariant1'
import { PurchaseVariant2 } from 'modules/purchase/pages/PurchaseVariant2'
import { SimplePage } from '../pages/simplePage'
import {
  CustomerReviews,
  FeelNervousDetailed,
  ThanksForSharing,
  FindYourMoodBalance,
  SelectGoal,
  FeelStressed,
  FacedWithFeelings,
} from '../pages/questions'
import { Result } from '../pages/result'
import { Download } from '../pages/download'
import { Email, EmailV2 } from '../pages/email'

export const enum PageId {
  FIND_YOUR_MOOD_BALANCE = 'find_your_mood_balance',
  SELECT_GOAL = 'select_goal',
  FEEL_STRESSED = 'feel_stressed',
  FACED_WITH_FEELINGS = 'faced_with_feelings',
  FEEL_NERVOUS = 'feel_nervous',
  FEEL_NERVOUS_DETAILED = 'feel_nervous_detailed',
  DAILY_REGIME = 'daily_regime',
  FEEL_TIRED = 'feel_tired',
  FOUND_UPSET = 'found_upset',
  CUSTOMER_REVIEWS = 'customer_reviews',
  FOUND_IMPATIENT = 'found_impatient',
  UNABLE_TO_CONTROL = 'unable_to_control',
  FEEL_SCARED = 'feel_scared',
  THANKS_FOR_SHARING = 'thanks_for_sharing',
  ENTER_EMAIL = 'enter_email',
  ENTER_EMAIL_V2 = 'enter_email_v2',
  RESULT = 'result',
  PURCHASE = 'purchase',
  PURCHASE_V2 = 'purchase2',
  DOWNLOAD = 'download',
}

export const ID_TO_PAGE_MAP: TIdToPageMap = {
  find_your_mood_balance: FindYourMoodBalance,
  select_goal: SelectGoal,
  feel_stressed: FeelStressed,
  faced_with_feelings: FacedWithFeelings,
  feel_nervous: SimplePage,
  feel_nervous_detailed: FeelNervousDetailed,
  daily_regime: SimplePage,
  feel_tired: SimplePage,
  found_upset: SimplePage,
  customer_reviews: CustomerReviews,
  found_impatient: SimplePage,
  unable_to_control: SimplePage,
  feel_scared: SimplePage,
  thanks_for_sharing: ThanksForSharing,
  enter_email: Email,
  enter_email_v2: EmailV2,
  result: Result,
  purchase: PurchaseVariant1,
  purchase2: PurchaseVariant2,
  download: Download,
}

export const DYNAMIC_PAGES_SET_VARIANT_1: IDynamicPage[] = [
  { id: PageId.FIND_YOUR_MOOD_BALANCE, hasBurgerMenu: true },
  { id: PageId.FEEL_NERVOUS },
  { id: PageId.FEEL_NERVOUS_DETAILED },
  { id: PageId.DAILY_REGIME },
  { id: PageId.FEEL_TIRED },
  { id: PageId.FOUND_UPSET },
  { id: PageId.CUSTOMER_REVIEWS },
  { id: PageId.FOUND_IMPATIENT },
  { id: PageId.UNABLE_TO_CONTROL },
  { id: PageId.FEEL_SCARED },
  { id: PageId.THANKS_FOR_SHARING },
]

export const DYNAMIC_PAGES_SET_VARIANT_2: IDynamicPage[] = [
  { id: PageId.SELECT_GOAL, hasBurgerMenu: true },
  { id: PageId.FEEL_STRESSED },
  { id: PageId.FACED_WITH_FEELINGS },
  { id: PageId.DAILY_REGIME },
  { id: PageId.FEEL_TIRED },
  { id: PageId.FOUND_UPSET },
  { id: PageId.CUSTOMER_REVIEWS },
  { id: PageId.FOUND_IMPATIENT, hasQuestionDescription: true },
  { id: PageId.UNABLE_TO_CONTROL, hasQuestionDescription: true },
  { id: PageId.FEEL_SCARED, hasQuestionDescription: true },
  { id: PageId.THANKS_FOR_SHARING },
]

export const DYNAMIC_PAGES_MAP: Record<Cohort, IDynamicPage[]> = {
  [Cohort.VARIANT_ONE]: DYNAMIC_PAGES_SET_VARIANT_1,
  [Cohort.VARIANT_TWO]: DYNAMIC_PAGES_SET_VARIANT_2,
}

export const EMAIL_PAGES: IDynamicPage[] = [
  { id: PageId.ENTER_EMAIL },
  { id: PageId.ENTER_EMAIL_V2 },
]

export const PURCHASE_PAGES: IDynamicPage[] = [
  { id: PageId.PURCHASE },
  { id: PageId.PURCHASE_V2 },
]

export const PURCHASE_PAGES_MAP: Record<Cohort, PageId> = {
  [Cohort.VARIANT_ONE]: PageId.PURCHASE,
  [Cohort.VARIANT_TWO]: PageId.PURCHASE_V2,
}
